import { render, staticRenderFns } from "./plDeratedDetail.vue?vue&type=template&id=6ac53124&scoped=true&"
import script from "./plDeratedDetail.vue?vue&type=script&lang=js&"
export * from "./plDeratedDetail.vue?vue&type=script&lang=js&"
import style0 from "./plDeratedDetail.vue?vue&type=style&index=0&id=6ac53124&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac53124",
  null
  
)

export default component.exports